import {
  SingeValueReport,
  SingleValueReportContext,
} from '@bm-js/atlas-analytics'
import { Spinner } from '@heroui/spinner'
import { CText } from '@bm-js/atlascloud-ui'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { useTr } from '../utils/useTr'

type Props = {
  context: SingleValueReportContext
  data: SingeValueReport | null
  loading: boolean
}

// prettier-ignore
const reportMap: Record<SingleValueReportContext, TrKey> = {
  [SingleValueReportContext.totalPageViews]: TrKey.analyticsTotalPageViews,
  [SingleValueReportContext.uniqueUsers]: TrKey.analyticsUniqueUsers,
  [SingleValueReportContext.avgEngagementTime]: TrKey.analyticsAvgEngagementTime,
  [SingleValueReportContext.pageViewsLast5Minutes]: TrKey.analyticsPageViewsLast5Minutes,
  [SingleValueReportContext.uniqueUsersLast5Minutes]: TrKey.analyticsUniqueUsersLast5Minutes,
}

const AnalyticsSingleValue = ({ context, data, loading }: Props) => {
  const { tr } = useTr()
  return (
    <div className='text-center border border-neutral-400 p-4 rounded-lg'>
      {loading ? (
        <div className='h-20 w-48 flex items-center justify-center text-primary-400'>
          <Spinner color='current' />
        </div>
      ) : (
        <>
          <CText tag='h3' className='uppercase text-sm'>
            {tr(reportMap[context])}
          </CText>
          <CText className='!text-3xl font-bold mt-2'>
            {data?.value || '-'}
          </CText>
        </>
      )}
    </div>
  )
}

export default AnalyticsSingleValue
